export default __webpack_public_path__ + "static/media/FR.db62f2f8.svg";